import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircleIcon } from 'lucide-react';
export function CardMonitoringPrograms() {
  const navigate = useNavigate();
  return <div className="max-w-5xl mx-auto" data-id="element-6685">
      <h1 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-6686">
        Card monitoring programs
      </h1>
      <p className="text-gray-700 mb-2" data-id="element-6687">
        Card networks require that you keep dispute and fraud at acceptable
        levels. If your business exceeds the limits dictated by the networks
        (e.g., Visa or Mastercard) you're placed into one of their monitoring
        programs.{' '}
        <a href="#" className="text-blue-600 hover:text-blue-700 underline" data-id="element-6688">
          Learn more
        </a>
      </p>

      <div className="mt-8" data-id="element-6689">
        <button onClick={() => navigate('/card-monitoring/vamp')} className="w-full bg-white border border-gray-200 rounded-lg p-6 hover:border-blue-300 hover:shadow-sm transition-all text-left group" data-id="element-6690">
          <h2 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-600 transition-colors" data-id="element-6691">
            Visa Acquirer Monitoring Program (VAMP)
          </h2>
          <div className="flex items-center gap-2 text-green-600" data-id="element-6692">
            <CheckCircleIcon size={20} data-id="element-6693" />
            <span className="text-sm font-medium" data-id="element-6694">In good standing</span>
          </div>
        </button>
      </div>
    </div>;
}